<div class="container-fluid" style="padding: 16px">
  <h3>CCO Test (Admin)</h3>
  <p class="text-muted">
    Create a Capacity Order directly against the Capacity Order service for testing. This bypasses the plan-approval
    workflow and the <code>EnableCapacityOrder</code> feature gate. Intended for non-production (UAT/PPE) validation.
  </p>

  <div class="card" style="margin-bottom: 16px">
    <div class="card-header"><strong>Order details</strong></div>
    <div class="card-body">
      <div class="form-row" style="display: flex; flex-wrap: wrap; gap: 12px">
        <div class="form-group" style="flex: 1 1 240px">
          <label>Service Tree Id</label>
          <ng-select
            [items]="teamOptions"
            bindLabel="Label"
            bindValue="Oid"
            placeholder="Search service tree..."
            [(ngModel)]="serviceTreeId"
            (ngModelChange)="onServiceTreeIdChange()"
          >
          </ng-select>
        </div>
        <div class="form-group" style="flex: 1 1 200px">
          <label>Region</label>
          <ng-select
            [items]="regionOptions"
            bindLabel="Label"
            bindValue="RegionName"
            placeholder="Search region..."
            [(ngModel)]="region"
            (ngModelChange)="onRegionChange()"
          >
          </ng-select>
        </div>
        <div class="form-group" style="flex: 1 1 200px">
          <label>Service Team</label>
          <input class="form-control" type="text" [(ngModel)]="serviceTeam" />
        </div>
        <div class="form-group" style="flex: 1 1 200px">
          <label>Team Contact</label>
          <input class="form-control" type="text" [(ngModel)]="teamContact" />
        </div>
        <div class="form-group" style="flex: 1 1 160px">
          <label>Blueprint / Stage</label>
          <input class="form-control" type="text" [(ngModel)]="blueprint" />
        </div>
        <div class="form-group" style="flex: 1 1 200px">
          <label>Need By Date (optional)</label>
          <input class="form-control" type="date" [(ngModel)]="needByDate" />
        </div>
        <div class="form-group" style="flex: 0 0 auto; display: flex; align-items: center; margin-top: 24px">
          <label style="margin: 0">
            <input type="checkbox" [(ngModel)]="isHobo" /> Is HoBo
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="card" style="margin-bottom: 16px">
    <div class="card-header" style="display: flex; justify-content: space-between; align-items: center">
      <strong>Resources</strong>
      <div>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="loadVmSkus()">Load VM SKUs for region</button>
        <button class="btn btn-sm btn-primary" type="button" (click)="addResource()">Add resource</button>
      </div>
    </div>
    <div class="card-body">
      <table class="table table-sm">
        <thead>
          <tr>
            <th style="width: 22%">Resource type</th>
            <th style="width: 12%">Service</th>
            <th style="width: 12%">Unit</th>
            <th style="width: 24%">SKU</th>
            <th style="width: 12%">Quota</th>
            <th style="width: 12%">Subscriptions</th>
            <th style="width: 6%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of resources; let i = index">
            <td>
              <select class="form-control form-control-sm" [(ngModel)]="row.presetLabel" (ngModelChange)="onPresetChange(row)">
                <option *ngFor="let preset of resourceTypePresets" [value]="preset.label">{{ preset.label }}</option>
              </select>
            </td>
            <td>{{ row.Service }}</td>
            <td>{{ row.Unit }}</td>
            <td>
              <ng-select
                *ngIf="row.requiresSku && vmSkuOptions.length > 0"
                [items]="vmSkuOptions"
                placeholder="Search SKU..."
                [(ngModel)]="row.Sku"
              >
              </ng-select>
              <input
                *ngIf="row.requiresSku && vmSkuOptions.length === 0"
                class="form-control form-control-sm"
                type="text"
                [(ngModel)]="row.Sku"
              />
              <span *ngIf="!row.requiresSku" class="text-muted">n/a</span>
            </td>
            <td>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="row.Quota" min="0" />
            </td>
            <td>
              <input class="form-control form-control-sm" type="number" [(ngModel)]="row.SubscriptionCount" min="1" />
            </td>
            <td>
              <button class="btn btn-sm btn-outline-danger" type="button" (click)="removeResource(i)">Remove</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-muted" style="font-size: 12px">
        VM cores and Batch low-priority cores require a SKU. Click "Load VM SKUs for region" to pick a valid CRP SKU from the
        selected region.
      </div>
    </div>
  </div>

  <div style="margin-bottom: 16px">
    <button class="btn btn-success" type="button" (click)="createOrder()">Create capacity order</button>
  </div>

  <div class="card" style="margin-bottom: 16px">
    <div class="card-header"><strong>Get / Delete existing order</strong></div>
    <div class="card-body">
      <div style="display: flex; gap: 12px; align-items: flex-end; flex-wrap: wrap">
        <div class="form-group" style="flex: 1 1 320px">
          <label>Order Id</label>
          <input class="form-control" type="text" [(ngModel)]="lookupOrderId" />
        </div>
        <div class="form-group">
          <button class="btn btn-info" type="button" (click)="getOrder()">Get status</button>
          <button class="btn btn-danger" type="button" (click)="deleteOrder()">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header"><strong>Response</strong></div>
    <div class="card-body">
      <pre style="max-height: 420px; overflow: auto; background: #f6f8fa; padding: 12px">{{ responseText }}</pre>
    </div>
  </div>
</div>
